<template>
  <div class="bazaar-voice-wrapper">
    <slot />
  </div>
</template>

<script>
import { pushData } from 'Utils/datalayer';

const bvReviewsSelector = '.bv-placeholder';
export default {
  name: 'bazaarvoice-wrapper',
  props: {
    productId: { type: String, default: '' },
    productName: { type: String, default: '' },
  },
  data() {
    return {
      isScrolledContent: false,
      executed: false
    };
  },
  mounted() {
    this.configureBazaarvoice();
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    bvSubmissionSubmitted(data) {
      const { SubmittedStep, contentType } = data;
      if (contentType === "review") {
        switch (SubmittedStep) {
          case "mandatory":
            const key = 'eventName';
            const value = 'BV Submit Review Button Click';
            this.dataLayerPush(key, value);
            break;
          default:
            break;
        }
      }
    },
    bvSubmissionLoad(data) {
      const { contentType } = data;
      if (contentType === "review") {
            const key = 'eventName';
            const value = 'BV Write Review Button Click Event';
            this.dataLayerPush(key, value);
      }
    },
    dataLayerPush(key, value){
      const wsfEvents = window.wsf;
      wsfEvents.AnalyticsVariables.find((writeReview) => {
        if (writeReview[key] === value) {
          pushData(writeReview.eventProperties);
        }
      });
    },
    configureBazaarvoice() {
      window.bvCallback = (BV) => {

        BV.configure('global', {
          events: {
            submissionLoad: (data) => this.bvSubmissionLoad(data),
            submissionSubmitted: (data) => this.bvSubmissionSubmitted(data)
          }
        });
      };
    },

    onScroll() {
      let triggeredDataLayer = false;
      window.addEventListener('scroll', () => {
        const shaRoot = document.querySelector('.bvReviews__wrapper ' + bvReviewsSelector).shadowRoot;
        const regex = /(bv-review-\d{0,8})\w+/;
        if (shaRoot) {
          const bvReviews = Array.from(shaRoot.querySelectorAll('#reviews_container section')).filter(element => regex.test(element.id));
          if (bvReviews.length > 0) {
            const observer = new IntersectionObserver(entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.60 && !triggeredDataLayer) {
                  this.sendTaggingData();
                  triggeredDataLayer = true;
                  observer.disconnect();
                }
              });
            }, { threshold: [0.60] });
            observer.observe(bvReviews[0]);
          }
        }
      });
    },
    sendTaggingData() {
      window.removeEventListener('scroll', this.onScroll);
      pushData({
        event: 'uaevent',
        event_name: 'read_review',
        ecommerce: 'undefined',
        eventCategory: 'product detail page',
        eventAction: 'read review',
        eventLabel: `${this.productName}::${this.productId}`,
        product_info: `${this.productName}::${this.productId}`,
      });
    },
  },
};
</script>